import { useRef } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import About from './components/About';
import Projects from './components/Projects';
import Skills from './components/Skills';
import Experience from './components/Experience';
import Contact from './components/Contact';
import Footer from './components/Footer';
import DevHive from './components/DevHive';
import Notify from './components/Notify';
import ClimbOrDie from './components/ClimbOrDie';
import Swipe from './components/Swipe';
import DitherBackground from './components/DitherBackground';

function HomePage() {
  const refs = {
    about: useRef(null),
    projects: useRef(null),
    skills: useRef(null),
    experience: useRef(null),
    contact: useRef(null),
  };

  return (
    <div className="font-sans bg-white text-gray-800">
      <Navbar refs={refs} />
      <section ref={refs.hero}><Hero /></section>
      <section ref={refs.about}><About /></section>
      <section ref={refs.projects}><Projects /></section>
      <section ref={refs.skills}><Skills /></section>
      <section ref={refs.experience}><Experience /></section>
      <section ref={refs.contact}><Contact /></section>
      <Footer />
    </div>
  );
}

function App() {
  return (
    <Router>
      <DitherBackground />
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/devhive" element={<DevHive />} />
        <Route path="/notify" element={<Notify />} />
        <Route path="/climbor-die" element={<ClimbOrDie />} />
        <Route path="/swipe" element={<Swipe />} />
      </Routes>
    </Router>
  );
}

export default App;
